import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { LangKey } from '@/utils/types/langKey';
import enLocaleResource from '@/locales/en.json';
import zhLocaleResource from '@/locales/zh.json';
import frLocaleResource from '@/locales/fr.json';
import esLocaleResource from '@/locales/es-MX.json';
import jaLocaleResource from '@/locales/ja.json';
import koLocaleResource from '@/locales/ko.json';
import deLocaleResource from '@/locales/de.json';
import ptLocaleResource from '@/locales/pt-BR.json';
import viLocaleResource from '@/locales/vi.json';

import { getLangFromLocalStorage } from './localstorage';

const DEFAULT_LANG = 'en';

function isValidLang(lang: string | undefined): lang is LangKey {
  return !!lang && Object.keys(LangKey).includes(lang);
}

export function getLangFromBrowser(lang = window.navigator.language || DEFAULT_LANG) {
  return lang.split('-')[0];
}

/*
 * Language can be changed later with merchant defined language, if any.
 * We'll need to include merchantDefined to make it independent of latter API calls.
 */
export function resolveLanguage() {
  let lang = getLangFromLocalStorage();
  if (isValidLang(lang)) return lang;

  lang = getLangFromBrowser();
  if (isValidLang(lang)) return lang;

  return DEFAULT_LANG;
}

i18n
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    lng: resolveLanguage(),
    fallbackLng: 'en',
    keySeparator: '.',
    preload: ['en', 'zh', 'fr', 'es', 'ja', 'ko', 'de', 'pt', 'vi'],
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    react: {
      useSuspense: false,
      transSupportBasicHtmlNodes: true,
      transKeepBasicHtmlNodesFor: ['b', 'br'],
    },
    resources: {
      en: {
        translation: enLocaleResource,
      },
      zh: {
        translation: zhLocaleResource,
      },
      fr: {
        translation: frLocaleResource,
      },
      es: {
        translation: esLocaleResource,
      },
      ja: {
        translation: jaLocaleResource,
      },
      ko: {
        translation: koLocaleResource,
      },
      de: {
        translation: deLocaleResource,
      },
      pt: {
        translation: ptLocaleResource,
      },
      vi: {
        translation: viLocaleResource,
      },
    },
  });

export default i18n;
